import { render, staticRenderFns } from "./dialog-snackbarmultirestore.vue?vue&type=template&id=0486d19c&"
import script from "./dialog-snackbarmultirestore.vue?vue&type=script&lang=js&"
export * from "./dialog-snackbarmultirestore.vue?vue&type=script&lang=js&"
import style0 from "./dialog-snackbarmultirestore.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports